import type { SlotDesign } from "src/components/greeting-card/design-data";
import { writeDraft, clearDraft } from "./card-draft-store";

export function createDraftSaver(
  key: string,
  opts?: { debounceMs?: number; now?: () => number },
): { onChange: (slots: SlotDesign[]) => void; flush: () => void; clear: () => void } {
  const debounceMs = opts?.debounceMs ?? 1500;
  const now = opts?.now ?? (() => Date.now());
  let timer: ReturnType<typeof setTimeout> | null = null;
  let pending: SlotDesign[] | null = null;

  const cancel = () => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };

  const write = () => {
    if (pending) {
      writeDraft(key, pending, now());
      pending = null;
    }
  };

  return {
    onChange(slots) {
      pending = slots;
      cancel();
      timer = setTimeout(() => {
        timer = null;
        write();
      }, debounceMs);
    },
    flush() {
      cancel();
      write();
    },
    clear() {
      cancel();
      pending = null;
      clearDraft(key);
    },
  };
}
